export default "__VITE_ASSET__dXhC1vJk__"